import { render, staticRenderFns } from "./ZnsCampaign.vue?vue&type=template&id=890c4ca4"
import script from "./ZnsCampaign.vue?vue&type=script&lang=js"
export * from "./ZnsCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports